import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ palette, breakpoints, custom }: Theme) => ({
    paper: {
      margin: 10,
    },
    navigationContainer: {
      padding: '100px 15px 10px 10px',
    },
    dayNameButton: {
      fontSize: 14,
      lineHeight: 1.8,
      cursor: 'pointer',
      '&:hover': {
        color: palette.primary.main,
      },
    },
    dialogTitle: {
      padding: 20,
    },
    dialogClose: {
      position: 'absolute',
      right: 5,
      top: 5,
      cursor: 'pointer',
      padding: 5,
    },
    dialogContent: {
      padding: 0,
      paddingBottom: 2,
      width: 350,
      overflow: 'hidden',
    },
    loader: {
      height: 285,
      width: 350,
    },
    timePickerView: {
      padding: '0 7px',
      width: 350,
      overflowY: 'auto',
      [breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    timePickerTitle: {
      textAlign: 'center',
      marginBottom: 20,
      '& h3': {
        margin: 0,
        fontWeight: 'normal',
        fontSize: 14,
        color: palette.text.primary,
      },
    },
    timePickerContainer: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    timePickerItem: {
      overflow: 'hidden',
      cursor: 'pointer',
      textAlign: 'center',
      maxWidth: 'calc(100% / 3)',
      flexBasis: 'calc(100% / 3)',
      padding: '2em 0.5em',
      borderRadius: 4,
      boxSizing: 'border-box',
      border: `2px solid ${palette.common.white}`,
      '&:hover': {
        border: `2px solid ${custom.status.warning.contrastText}`,
        backgroundColor: custom.status.warning.main,
      },
    },
    timePickerText: {
      margin: 0,
      fontSize: 14,
      textAlign: 'center',
      display: 'block',
    },
  })
);
